<router-outlet></router-outlet>
<p-toast [breakpoints]="{ '767px': { width: '100%', right: '0'} }"></p-toast>
<p-confirmDialog i18n-header header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>